export const getDropdownPopupContainer = (triggerNode: HTMLElement): HTMLElement => {
  return triggerNode.ownerDocument.body;
};
